import { render, staticRenderFns } from "./PersonaPage.vue?vue&type=template&id=04b90388&scoped=true&"
import script from "./PersonaPage.js?vue&type=script&lang=js&"
export * from "./PersonaPage.js?vue&type=script&lang=js&"
import style0 from "./PersonaPage.vue?vue&type=style&index=0&id=04b90388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b90388",
  null
  
)

export default component.exports